import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AppConfig } from '@domgen/dgx-components';
import { CONFIG } from '@domgen/dgx-fe-config';
import { map } from 'rxjs';
import { SmartFixBanner } from '../manage-my-repair/components/smart-fix-banner/smart-fix-banner';

interface NoRepairDTO {
  title: string;
  smartFixBanner: {
    smartFixBanner0?: SmartFixBanner;
  };
}

@Injectable()
export class CmsService {
  constructor(
    private httpClient: HttpClient,
    @Inject(CONFIG) private readonly config: AppConfig
  ) {}

  getSmartFixBannerConfig() {
    const httpOptions = {
      withCredentials: false,
    };
    return this.httpClient
      .get<NoRepairDTO>(
        this.config.magnoliaApi + 'my-account/No-repair',
        httpOptions
      )
      .pipe(map((page) => page?.smartFixBanner?.smartFixBanner0));
  }
}
